import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { CCChangeSubsection, EMailChangeSubsection, PageLoading, PasswordChangeSubsection, PlanSubsection, ProfileDetailSubsection, ProfileChangeSubsection, } from '@lean-body/components/organisms';
import { SettingMenu, SettingItemKeys, SettingItems } from '../organisms/setting_menu';
import { Colors, MediaBreakPointUp, Sizes } from '../styles';
import { useLocation } from 'react-router-dom';
import { useQuery, useXlMediaQuery } from '@lean-body/src/util';
import { settingMenuWidth } from '@lean-body/src/view/styles/utils';
import { NotificationSettingSubsection } from '../organisms/notification_setting_subsection';
import { HealthCareConnect } from '../organisms/health_care_connect';
import { DisplaySettingSubsection } from '../organisms/display_setting_subsection';
export const SettingPage = ({ accountService, apiClient, alertPresenter, config, tracker, profile, setProfile, }) => {
    var _a;
    const location = useLocation();
    const query = useQuery();
    const isXL = useXlMediaQuery();
    const [me, setMe] = React.useState();
    const [currentItem, setCurrentItem] = React.useState(SettingItemKeys[query.get('key')]);
    const payment = me === null || me === void 0 ? void 0 : me.payment;
    const title = ((_a = SettingItems[currentItem]) === null || _a === void 0 ? void 0 : _a.text) || '設定';
    const necessaryTitle = !(currentItem === SettingItemKeys.mypage || currentItem === SettingItemKeys.editMypage);
    const hideMenu = !isXL && currentItem;
    React.useEffect(() => {
        accountService.fetchMe({ nocache: true }).then((v) => setMe(v));
    }, []);
    React.useEffect(() => {
        setCurrentItem(query.get('key'));
    }, [location]);
    const onClick = (key) => {
        setCurrentItem(key);
        window.scrollTo(0, 0);
    };
    if (!me || !profile) {
        return React.createElement(PageLoading, null);
    }
    return (React.createElement("div", { className: css(styles.container) },
        !hideMenu && (React.createElement(SettingMenu, { currentItem: currentItem, onClick: onClick, isMegalosUser: payment === null || payment === void 0 ? void 0 : payment.isMegalosUser, me: me, isStripeUser: payment === null || payment === void 0 ? void 0 : payment.isStripePayment(), onClickSignOut: () => {
                accountService.signOut();
            }, profile: profile })),
        React.createElement("div", { className: css(styles.item) },
            currentItem && necessaryTitle && (React.createElement("div", { className: css(styles.titleForItem) },
                title,
                currentItem === SettingItemKeys.plan && me.isDormant && (React.createElement(React.Fragment, null,
                    "\uFF08",
                    React.createElement("span", { className: css(styles.titleForItemAccent) }, "\u4F11\u7720\u4E2D"),
                    "\uFF09")))),
            currentItem === SettingItemKeys.mypage && (React.createElement(ProfileDetailSubsection, { classObject: styles.centerAlignedSection, setItemKey: setCurrentItem, profile: profile })),
            currentItem === SettingItemKeys.editMypage && (React.createElement(ProfileChangeSubsection, { classObject: styles.centerAlignedSection, apiClient: apiClient, alertPresenter: alertPresenter, setItemKey: setCurrentItem, profile: profile, setProfile: setProfile, tracker: tracker })),
            currentItem === SettingItemKeys.displaySetting && (React.createElement(DisplaySettingSubsection, { apiClient: apiClient, profile: profile, setProfile: setProfile, classObject: styles.section })),
            currentItem === SettingItemKeys.notification && React.createElement(NotificationSettingSubsection, { apiClient: apiClient }),
            currentItem === SettingItemKeys.healthCare && React.createElement(HealthCareConnect, { classObject: styles.section }),
            currentItem === SettingItemKeys.email && (React.createElement(EMailChangeSubsection, { accountService: accountService, apiClient: apiClient, alertPresenter: alertPresenter, me: me, classObject: styles.section })),
            currentItem === SettingItemKeys.password && (React.createElement(PasswordChangeSubsection, { accountService: accountService, apiClient: apiClient, alertPresenter: alertPresenter, me: me, classObject: styles.section })),
            currentItem === SettingItemKeys.payment && (React.createElement(CCChangeSubsection, { accountService: accountService, apiClient: apiClient, alertPresenter: alertPresenter, config: config, me: me, setMe: setMe, classObject: styles.section })),
            currentItem === SettingItemKeys.plan && (React.createElement(PlanSubsection, { accountService: accountService, apiClient: apiClient, alertPresenter: alertPresenter, tracker: tracker, me: me, classObject: styles.section, setMe: setMe })))));
};
const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.White,
        minHeight: `calc(100vh - ${Sizes.MobileHeaderHeight}px)`,
        [MediaBreakPointUp.MD]: {
            minHeight: '100vh',
        },
        [MediaBreakPointUp.XL]: {
            display: 'flex',
        },
    },
    titleForItem: {
        fontSize: 18,
        fontWeight: 'bold',
        padding: '30px 30px 24px',
    },
    titleForItemAccent: {
        color: Colors.Accent,
    },
    section: {
        margin: '0 30px',
    },
    centerAlignedSection: {
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingTop: 40,
        paddingBottom: 70,
        [MediaBreakPointUp.MD]: {
            paddingBottom: 100,
        },
    },
    item: {
        width: '100%',
        flex: 1,
        backgroundColor: Colors.White,
        [MediaBreakPointUp.XL]: {
            marginLeft: settingMenuWidth.xl,
        },
    },
});
export const SettingStyles = StyleSheet.create({
    button: {
        display: 'block',
        width: '100%',
        height: 50,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: '0.56px',
        [MediaBreakPointUp.MD]: {
            maxWidth: 315,
            margin: '0 auto',
        },
    },
});
